import React from 'react';

export const VerticalFlexBox = props => (
    <div className="vertical-flex-box">{props.children}</div>
);

export default VerticalFlexBox;


// WEBPACK FOOTER //
// ./src/components/common/VerticalFlexBox.js